// SupportedDataSources.js
import React from 'react';
import { Box, Grid, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';

export default function SupportedDataSources() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        Supported Data Sources
      </Typography>
          <Typography paragraph>
            PostSheet lets you pull data from your everyday tools:
          </Typography>

          <List
            sx={{
              listStyleType: 'disc',
              pl: 3,
              '& .MuiListItem-root': { display: 'list-item', py: 0.5 },
            }}
          >
            <ListItem>
              <strong>Spreadsheets &amp; Files:</strong> XLS, XLSX, CSV
            </ListItem>
            <ListItem>
              <strong>Online Sheets:</strong> Google Sheets
            </ListItem>
            <ListItem>
              <strong>Cloud Tables:</strong> Airtable
            </ListItem>
            <ListItem>
              <strong>Relational Databases:</strong> PostgreSQL, MySQL, SQL
              Server, Oracle
            </ListItem>
          </List>

          <Typography paragraph sx={{ mt: 2 }}>
            Each workspace can register up&nbsp;to&nbsp;five live database
            connections.
          </Typography>


        {/* ───────── Right-hand image column ───────── */}

          <img
            src="../../static/docs/NewCampaign.jpg"
            alt="New campaign data-source picker"
            className="step-img"
          />

    </Box>
  );
}
